import { render, staticRenderFns } from "./SkillEditorScreen.vue?vue&type=template&id=26bd525a&scoped=true&"
import script from "./SkillEditorScreen.vue?vue&type=script&lang=js&"
export * from "./SkillEditorScreen.vue?vue&type=script&lang=js&"
import style0 from "./SkillEditorScreen.vue?vue&type=style&index=0&id=26bd525a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bd525a",
  null
  
)

export default component.exports